<template>
  <svg
    class="calendar"
    xmlns="http://www.w3.org/2000/svg"
    width="34.375"
    height="34.375"
    viewBox="0 0 34.375 34.375"
  >
    <path
      id="Forma_1"
      data-name="Forma 1"
      class="cls-1"
      d="M896.04,663.881a1.343,1.343,0,1,1-1.342,1.342A1.342,1.342,0,0,1,896.04,663.881Zm3.089-10.071h-1.746v-1.343a1.343,1.343,0,1,0-2.685,0v1.343h-6.11v-1.343a1.343,1.343,0,1,0-2.685,0v1.343H879.86v-1.343a1.343,1.343,0,0,0-2.686,0v1.343H875.5a5.377,5.377,0,0,0-5.371,5.371v20.948a5.376,5.376,0,0,0,5.371,5.37h10.272a1.343,1.343,0,1,0,0-2.685H875.5a2.688,2.688,0,0,1-2.685-2.685V659.181A2.688,2.688,0,0,1,875.5,656.5h1.678v1.343a1.343,1.343,0,0,0,2.686,0V656.5H885.9v1.343a1.343,1.343,0,1,0,2.685,0V656.5h6.11v1.343a1.343,1.343,0,1,0,2.685,0V656.5h1.746a2.688,2.688,0,0,1,2.685,2.686v7.654a1.343,1.343,0,1,0,2.686,0v-7.654A5.378,5.378,0,0,0,899.129,653.81Zm-2.753,15.442a8.124,8.124,0,1,0,8.124,8.124A8.133,8.133,0,0,0,896.376,669.252Zm0,13.562a5.439,5.439,0,1,1,5.438-5.438A5.445,5.445,0,0,1,896.376,682.814Zm1.947-6.781h-0.6v-1.41a1.343,1.343,0,1,0-2.686,0v2.753a1.343,1.343,0,0,0,1.343,1.342h1.947A1.343,1.343,0,1,0,898.323,676.033ZM890.2,663.881a1.343,1.343,0,1,1-1.342,1.342A1.342,1.342,0,0,1,890.2,663.881Zm-5.841,5.841a1.343,1.343,0,1,1-1.342,1.343A1.343,1.343,0,0,1,884.358,669.722Zm-5.841-5.841a1.343,1.343,0,1,1-1.343,1.342A1.342,1.342,0,0,1,878.517,663.881Zm0,5.841a1.343,1.343,0,1,1-1.343,1.343A1.343,1.343,0,0,1,878.517,669.722Zm0,5.841a1.343,1.343,0,1,1-1.343,1.343A1.343,1.343,0,0,1,878.517,675.563Zm5.841,0a1.343,1.343,0,1,1-1.342,1.343A1.343,1.343,0,0,1,884.358,675.563Zm0-11.682a1.343,1.343,0,1,1-1.342,1.342A1.342,1.342,0,0,1,884.358,663.881Z"
      transform="translate(-870.125 -651.125)"
    />
  </svg>
</template>

<script>
export default {
  name: "calendar",
};
</script>

<style scoped>
.shp0 {
  fill: #959595;
}
.calendar {
  fill: currentColor;
}
</style>
